<div class="sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-column__center sp-width__full sp-padding__x2">
    <pre style="max-width: 100%; white-space: break-spaces"> {{ position_error | json }} </pre>
  </div>
</div>
